import { Flex, Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { Text } from "@chakra-ui/react";
import DateRangePicker from "components/Input/DateRangePicker";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import SelectPessoas from "components/Input/SelectPessoas";
import { DespesaQuery } from "features/relatorios/typings";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import SelectTipoData from "components/Input/SelectTipoData";
import { TipoDataConta } from "core/features/conta/typings";
import SelectFechamentosRateioPorMes from "components/Input/SelectFechamentosRateioPorMes";
import SelectCentroDeCusto from "../../../../../../../components/Input/SelectCentroDeCusto/index";

interface FormFiltrosProps {
  filtro: DespesaQuery;
  onChangeFiltro: (v: Partial<DespesaQuery>) => void;
}

function FormFiltros({ filtro, onChangeFiltro }: FormFiltrosProps) {
  return (
    <Flex flexDir="column" width="100%">
      <Box as={Row} gutter={32} mb={2}>
        <Col md={12}>
          <Text mb="2px" fontSize="13px">
            Tipo de data
          </Text>
          <SelectTipoData
            bg="white"
            style={{ border: "1px solid #ccc", borderRadius: 6 }}
            value={filtro.tipoData}
            onChange={(v: TipoDataConta) =>
              onChangeFiltro({
                tipoData: v,
              })
            }
          />
        </Col>
        <Box as={Col} xs={12}>
          <Text mb="5px">Período</Text>
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: true,
              dataFim: false,
            }}
            onChange={(dataInicio, dataFim) => {
              onChangeFiltro({
                dataInicio,
                dataFim,
              });
            }}
            value={{
              dataFim: filtro.dataFim!,
              dataInicio: filtro.dataInicio!,
            }}
          />
        </Box>
      </Box>

      <Box as={Row} mt="16px" gutter={32}>
        <Box as={Col} xs={12}>
          <Text fontSize="14px" mb="6px">
            Conta categoria
          </Text>
          <SelectContaCategoria
            multiple
            value={filtro.categoriaIds}
            placeholder="Todas as contas categorias"
            onChange={(v) => {
              onChangeFiltro({ categoriaIds: v.length ? v : [] });
            }}
          />
        </Box>
        <Box as={Col} xs={12}>
          <Text fontSize="14px" mb="6px">
            Conta bancária
          </Text>
          <SelectContaBancaria
            mode="multiple"
            onChange={(v) =>
              onChangeFiltro({ contaBancariaIds: v.length ? v : undefined })
            }
            value={filtro.contaBancariaIds}
            placeholder="Todas as contas bancárias"
          />
        </Box>
      </Box>

      <Box as={Row} mt="16px" gutter={32}>
        <Box as={Col} xs={12}>
          <Text fontSize="14px" mb="6px">
            Favorecido
          </Text>
          <SelectPessoas
            value={filtro.pessoaId}
            tipoEntidades={[
              TipoEntidadeEnum.Fornecedor,
              TipoEntidadeEnum.Condomino,
              TipoEntidadeEnum.Funcionario,
              TipoEntidadeEnum.Outros,
            ]}
            placeholder="Selecione"
            onChange={(v) => onChangeFiltro({ pessoaId: v })}
          />
        </Box>

        <Box as={Col} xs={12}>
          <Text fontSize="14px" mb="6px">
            Rateio
          </Text>
          <SelectFechamentosRateioPorMes
            value={filtro.rateioFechamentoId}
            allowClear
            placeholder="Selecione"
            onChange={(v) => onChangeFiltro({ rateioFechamentoId: v })}
          />
        </Box>
      </Box>

      <Box as={Row} mt="16px" gutter={32}>
        <Box as={Col} md={24} mb={4}>
          <Text mb="2px" fontSize="13px">
            Centro de custo
          </Text>
          <SelectCentroDeCusto
            allowClear
            placeholder="Todos os centros de custo"
            value={filtro.centrosDeCustoIds}
            mode="multiple"
            onChange={(v) =>
              v.length
                ? onChangeFiltro({ centrosDeCustoIds: v })
                : onChangeFiltro({ centrosDeCustoIds: undefined })
            }
          />
        </Box>
      </Box>
    </Flex>
  );
}

export default FormFiltros;
